import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { DEFAULT_AUDIENCES } from "../banner/constants";
import { DEFAULT_AUDIENCES_CONFIG, DISMISS_ACTIVE_BANNER_EVENT_NAME } from "./constants";
export var dispatchDismissActiveBannerEvent = function dispatchDismissActiveBannerEvent() {
  window.dispatchEvent(new Event(DISMISS_ACTIVE_BANNER_EVENT_NAME));
};
export var testAuthenticationAudience = function testAuthenticationAudience(isUserAuthenticated, isAuthenticationRequired) {
  return isAuthenticationRequired === null || isAuthenticationRequired === isUserAuthenticated;
};
export var testCookieBannerAudience = function testCookieBannerAudience(isCookieBannerVisible, shouldCookieBannerBeVisible) {
  return shouldCookieBannerBeVisible === null || shouldCookieBannerBeVisible === isCookieBannerVisible;
};
export var testLocalesAudience = function testLocalesAudience(localeConfig, bannerLocales) {
  return bannerLocales === null || Array.isArray(bannerLocales) && bannerLocales.includes(localeConfig);
};
export var testExperimentVariationAudience = function testExperimentVariationAudience() {
  var experiments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var bannerExperimentVariations = arguments.length > 1 ? arguments[1] : undefined;
  var experimentObjects = Object.values(experiments);
  return bannerExperimentVariations === null || Array.isArray(bannerExperimentVariations) && bannerExperimentVariations.some(function (bannerVariationId) {
    return experimentObjects.find(function (_ref) {
      var variationId = _ref.variationId;
      return bannerVariationId === variationId;
    });
  });
};
export var testUrlsAudience = function testUrlsAudience(currentUrl, urls) {
  if (urls === null) {
    return true;
  }
  if (!Array.isArray(urls)) {
    return false;
  }
  // Separate the urls into includes and excludes
  var groupedUrls = urls.reduce(function (prev, url) {
    var copy = _objectSpread({}, prev);
    if (url.startsWith('!')) {
      copy.excludes.push(url.substring(1));
    } else {
      copy.includes.push(url);
    }
    return copy;
  }, {
    includes: [],
    excludes: []
  });
  var iterator = function iterator(url) {
    if (url.endsWith('*')) {
      return currentUrl.startsWith(url.replace('*', ''));
    } else {
      return currentUrl === url;
    }
  };
  var includes = groupedUrls.includes,
    excludes = groupedUrls.excludes;
  // If there are any excluded urls then they take precendence over included ones.
  if (excludes.length > 0) {
    var isExcluded = Boolean(excludes.find(iterator));
    return !isExcluded;
  }
  var isIncluded = Boolean(includes.find(iterator));
  return isIncluded;
};
export var testUtils = {
  testLocalesAudience: testLocalesAudience,
  testCookieBannerAudience: testCookieBannerAudience,
  testAuthenticationAudience: testAuthenticationAudience,
  testUrlsAudience: testUrlsAudience,
  testExperimentVariationAudience: testExperimentVariationAudience
};
export var fulfillsClientSideAudiences = function fulfillsClientSideAudiences(banner, audiencesConfig) {
  var _audiences$isAuthenti, _audiences$shouldCook;
  var _banner$audiences = banner.audiences,
    audiences = _banner$audiences === void 0 ? {} : _banner$audiences;
  var isUserAuthenticated = audiencesConfig.isUserAuthenticated,
    isCookieBannerVisible = audiencesConfig.isCookieBannerVisible;
  var testAuthenticationAudience = testUtils.testAuthenticationAudience,
    testCookieBannerAudience = testUtils.testCookieBannerAudience;
  var isAuthenticationRequired = (_audiences$isAuthenti = audiences.isAuthenticationRequired) !== null && _audiences$isAuthenti !== void 0 ? _audiences$isAuthenti : DEFAULT_AUDIENCES.isAuthenticationRequired;
  var isAuthenticationAudienceValid = testAuthenticationAudience(isUserAuthenticated, isAuthenticationRequired);
  var shouldCookieBannerBeVisible = (_audiences$shouldCook = audiences.shouldCookieBannerBeVisible) !== null && _audiences$shouldCook !== void 0 ? _audiences$shouldCook : DEFAULT_AUDIENCES.shouldCookieBannerBeVisible;
  var isCookieBannerAudienceValid = testCookieBannerAudience(isCookieBannerVisible, shouldCookieBannerBeVisible);
  return isAuthenticationAudienceValid && isCookieBannerAudienceValid;
};
export var fulfillsGeneralAudiences = function fulfillsGeneralAudiences(banner, audiencesConfig) {
  var _audiences$locales, _audiences$experiment, _audiences$urls;
  var _banner$audiences2 = banner.audiences,
    audiences = _banner$audiences2 === void 0 ? {} : _banner$audiences2;
  var locale = audiencesConfig.locale,
    currentUrl = audiencesConfig.currentUrl,
    experiments = audiencesConfig.experiments;
  var testLocalesAudience = testUtils.testLocalesAudience,
    testUrlsAudience = testUtils.testUrlsAudience,
    testExperimentVariationAudience = testUtils.testExperimentVariationAudience;
  var locales = (_audiences$locales = audiences.locales) !== null && _audiences$locales !== void 0 ? _audiences$locales : DEFAULT_AUDIENCES.locales;
  var isLocalesAudienceValid = testLocalesAudience(locale, locales);
  var experimentVariations = (_audiences$experiment = audiences.experimentVariations) !== null && _audiences$experiment !== void 0 ? _audiences$experiment : DEFAULT_AUDIENCES.experimentVariations;
  var isExperimentVariationAudienceValid = testExperimentVariationAudience(experiments, experimentVariations);
  var urls = (_audiences$urls = audiences.urls) !== null && _audiences$urls !== void 0 ? _audiences$urls : DEFAULT_AUDIENCES.urls;
  var isUrlsAudienceValid = testUrlsAudience(currentUrl, urls);
  return isLocalesAudienceValid && isUrlsAudienceValid && isExperimentVariationAudienceValid;
};
export var getTargetedBanners = function getTargetedBanners(banners, audiencesConfig) {
  audiencesConfig = _objectSpread(_objectSpread({}, DEFAULT_AUDIENCES_CONFIG), audiencesConfig);
  var allAudiencesBanners = banners.filter(function (banner) {
    return fulfillsClientSideAudiences(banner, audiencesConfig) && fulfillsGeneralAudiences(banner, audiencesConfig);
  });
  var generalAudiencesBanners = banners.filter(function (banner) {
    return fulfillsGeneralAudiences(banner, audiencesConfig);
  });
  var shouldWaitForClientSide = allAudiencesBanners.length !== generalAudiencesBanners.length;
  if (shouldWaitForClientSide) {
    return [];
  }
  return banners.filter(function (banner) {
    return fulfillsClientSideAudiences(banner, audiencesConfig) && fulfillsGeneralAudiences(banner, audiencesConfig);
  });
};